import { request } from "./http";
import type { ModuleStatus, ProvisionResult, SeatPreview, Tenant } from "./types";

export function listTenants(includeInactive = false): Promise<Tenant[]> {
  return request("/tenants/", { params: { include_inactive: includeInactive || undefined } });
}

export function getTenant(id: string): Promise<Tenant> {
  return request(`/tenants/${id}`);
}

export interface TenantCreatePayload {
  legal_name: string;
  subdomain?: string;
  subscription_tier: string;
  admin_email: string;
  admin_full_name: string;
}

export function createTenant(payload: TenantCreatePayload): Promise<ProvisionResult> {
  return request("/tenants/", { method: "POST", body: payload });
}

export function updateTenant(id: string, patch: Partial<Tenant>): Promise<Tenant> {
  return request(`/tenants/${id}`, { method: "PATCH", body: patch });
}

export function listTenantModules(id: string): Promise<ModuleStatus[]> {
  return request(`/tenants/${id}/modules`);
}

export function enableModule(id: string, moduleCode: string): Promise<{ enabled: string[] }> {
  return request(`/tenants/${id}/modules/enable`, {
    method: "POST",
    body: { module_code: moduleCode },
  });
}

export function disableModule(id: string, moduleCode: string, cascade = false): Promise<{ disabled: string[] }> {
  return request(`/tenants/${id}/modules/disable`, {
    method: "POST",
    body: { module_code: moduleCode, cascade },
  });
}

export function previewSeats(
  id: string,
  changes: { subscription_tier?: string; max_users?: number },
): Promise<SeatPreview> {
  return request(`/tenants/${id}/seat-preview`, { params: changes });
}
